import { IonCol, IonRow } from "@ionic/react";

interface Props {
  path: string;
}

const LogoLogin: React.FC<Props> = ({ path }) => {
  return (
    <IonRow className="ion-justify-content-center">
      <IonCol size-lg="5" size-sm="10">
        <IonRow className="ion-justify-content-center">
          <img
            style={{
              maxHeight: 100,
              marginTop: 50,
            }}
            src={path}
            alt="loginImage"
          />
        </IonRow>
      </IonCol>
    </IonRow>
  );
};

export default LogoLogin;
